export default __webpack_public_path__ + "static/media/UAIcon.2ff53161.svg";